import { createContext, useContext, useReducer } from 'react';
import { bankReducer, initialState } from './reducer';

const BankContext = createContext();

export const BankProvider = ({ children }) => {
    const [state, dispatch] = useReducer(bankReducer, initialState);

    return <BankContext.Provider value={[state, dispatch]}>{children}</BankContext.Provider>;
};

export const useBankContext = () => {
    const context = useContext(BankContext);
    if (!context) {
        throw new Error('use Bank Context must be used within a Bank Provider');
    }
    return context;
};
